// Station IDs (technical names) as the prospects list shows them (CWA-208).

const NUMBERED = /^(.*?)(\d+)$/;

/** "DECOC522–DECOC524" when the IDs share a prefix and their numbers run without a gap; otherwise null. */
export const stationRange = (ids: string[]): string | null => {
  if (ids.length < 2) return null;
  const parsed = ids.map((id) => {
    const match = id.match(NUMBERED);
    return match ? { id, prefix: match[1], number: Number(match[2]) } : null;
  });
  if (parsed.some((p) => p === null)) return null;
  const sorted = (parsed as { id: string; prefix: string; number: number }[]).sort((a, b) => a.number - b.number);
  const consecutive = sorted.every(
    (p, i) => p.prefix === sorted[0].prefix && (i === 0 || p.number === sorted[i - 1].number + 1)
  );
  return consecutive ? `${sorted[0].id}–${sorted[sorted.length - 1].id}` : null;
};

/** One ID, a range, or the first ID and how many more; null when no ID is assigned. */
export const stationIdsLabel = (ids: string[]): string | null => {
  if (ids.length === 0) return null;
  if (ids.length === 1) return ids[0];
  return stationRange(ids) ?? `${ids[0]} +${ids.length - 1} more`;
};
